import {$members} from '@/services/'
const module = {
    namespaced: true,

    state: {
        items: [],
        item: {},
        meta: { pagination: {}}
    },

    getters: {
        items: state => state.items,
        item: state => state.item,
        meta: state => state.meta,
        options: state=>{

            let members = state.items.map(member=>{
                return {
                    text: `${member.first_name} ${member.last_name} (${member.email})`,
                    value: `${member.id}`
                }
            })

            return [
                {
                    text: "",
                    value: ''
                },
                ...members
            ]
        }
    },

    mutations: {
        ITEMS(state, value){
            state.items = value
        },

        ITEM(state,value){
            state.item = value
        },

        ADD_ITEM(state, value){
            state.items.push(value)
        },

        META(state, meta){
            state.meta = meta
        },
    },

    actions: {
        all({commit}, {config}){
            return $members.all(config).then(function(res){
                let {data, meta} = res.data
                commit('ITEMS', data)
                commit('META', meta)
                return res
            }).catch(function(error){
                this.debug('[client.store/actions/all]::Error', error)
            })
        },
        
        find({ commit }, { id, query }){  
            return $members.find(id, query)
            .then(resp => {
                commit('ITEM', resp.data)
                return resp
            })
        },
    }
}

export default module
